import { createSelector } from "@ngrx/store";
import { AppState } from "libs/tm-common/src/lib/store/reducers/reducers";

export const selectMaintenanceState = (state: AppState) => state.maintenance;

export const selectMaintenanceTime = createSelector(selectMaintenanceState, (state) => state.maintenanceTime);
